<template>
  <q-item
    class="c-list-item"
    :clickable="clickable"
    :active="active"
    :active-class="activeClass"
    :disable="disable"
    :dense="dense"
    :dark="dark"
    :to="to"
    :class="$attrs.class"
    @click="emit('click', $event)"
  >
    <slot />
  </q-item>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router";

const emit = defineEmits<{
  (e: "click", event: Event): void;
}>();

withDefaults(
  defineProps<{
    clickable?: boolean;
    active?: boolean;
    activeClass?: string;
    disable?: boolean;
    dense?: boolean;
    dark?: boolean;
    to?: RouteLocationRaw;
  }>(),
  {
    clickable: false,
    active: false,
    activeClass: "",
    disable: false,
    dense: false,
    dark: false,
    to: undefined,
  },
);
</script>

<style lang="scss" scoped>
// We have to use ths deep styling to overwrite quasar defaults
body.desktop {
  .q-item {
    &.c-list-item {
      @apply tw-overflow-hidden tw-border-t-gray-100 tw-p-6;

      :deep(.q-focus-helper) {
        background: rgb(var(--color-grey-300));
      }
    }

    &--bordered {
      @apply tw-border tw-border-gray-100;
    }
  }
}
</style>
